export const links = {
  social: [
    { title: "Twitter", to: "" },
    { title: "Facebook", to: "" },
    { title: "GitHub", to: "" },
    { title: "LinkedIn", to: "" },
    { title: "Telegram", to: "" },
  ],
  aboutUs: [
    { title: "Overview", to: "" },
    { title: "Contact Us", to: "" },
    { title: "Careers", to: "" },
    { title: "Blog", to: "" },
  ],
  usefulLinks: [
    { title: "Your Dashboard", to: "" },
    { title: "Topic list", to: "" },
    { title: "Article list", to: "" },
    { title: "Infographics", to: "" },
    { title: "Statistics", to: "" },
  ],
};
